var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as angular from 'angular';
var FeatureFlagService = /** @class */ (function () {
    function FeatureFlagService($http, featureFlagContext, context, $q) {
        this.$http = $http;
        this.context = context;
        this.endpoint = featureFlagContext.ServiceEndpoint;
        this.q = $q;
    }
    FeatureFlagService.prototype.getFeatureFlags = function (appName, env, features, params, cacheType) {
        var _this = this;
        if (params === void 0) { params = {}; }
        if (cacheType === void 0) { cacheType = 'noCache'; }
        if (features === undefined || features === null || features.length < 1)
            throw new Error("features parameter is empty");
        var deferred = this.q.defer();
        var FeatureFlagsResponse = this.getCachedFlagResponse(appName, features, params, cacheType);
        var FeatureFlagsResult = FeatureFlagsResponse["FeatureFlagsResult"];
        var evaluateFeatures = FeatureFlagsResponse["Features"];
        if (evaluateFeatures.length !== 0) {
            this.getResponseFromAPI(appName, env, evaluateFeatures, params).then(function (response) {
                var resultArray = Object.entries(response);
                resultArray.forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    _this.storeResponseinCache(appName, key, value, params, cacheType);
                    FeatureFlagsResult[key] = value;
                });
                deferred.resolve(FeatureFlagsResult);
            }, function (error) {
                console.error(error);
                deferred.reject(error);
            });
        }
        else
            deferred.resolve(FeatureFlagsResult);
        return deferred.promise;
    };
    FeatureFlagService.prototype.getCacheKey = function (appName, key, params) {
        if (params == null || Object.keys(params).length === 0)
            return ("FEATUREFLAG:" + appName.toUpperCase() + ":" + key.toUpperCase());
        return ("FEATUREFLAG:" + appName.toUpperCase() + ":" + key.toUpperCase() + ":" + JSON.stringify(params));
    };
    FeatureFlagService.prototype.storeResponseinCache = function (appName, key, value, params, cacheType) {
        var index = this.getCacheKey(appName, key, params);
        if (cacheType === 'sessionStorage')
            sessionStorage[index] = value;
        else if (cacheType === 'localStorage')
            localStorage[index] = value;
    };
    FeatureFlagService.prototype.getResponseFromAPI = function (appName, env, features, params) {
        if (params === void 0) { params = {}; }
        var url = this.endpoint + '/Evaluate?featureNames=' + features.join();
        var config;
        if (params || this.context) {
            params = params || {};
            angular.extend(params, this.context);
            config = {
                headers: {
                    'X-FlightContext': JSON.stringify(params),
                    'X-Application': appName,
                    'X-Environment': env
                }
            };
        }
        var promise = this.$http.get(url, config)
            .then(function (response) {
            return response.data;
        }, function (error) {
            console.error(error);
        });
        return promise;
    };
    FeatureFlagService.prototype.getCachedFlagResponse = function (appName, features, params, cacheType) {
        var _this = this;
        var FlagNotCached = new Array();
        var FeatureFlagsResult = {};
        features.forEach(function (flag) {
            var index = _this.getCacheKey(appName, flag, params);
            if (cacheType === 'sessionStorage') {
                if (sessionStorage[index] !== undefined && sessionStorage[index] !== null)
                    FeatureFlagsResult[flag] = (sessionStorage[index].toUpperCase() === "TRUE");
                else
                    FlagNotCached.push(flag);
            }
            else if (cacheType === 'localStorage') {
                if (localStorage[index] !== undefined && localStorage[index] !== null) {
                    FeatureFlagsResult[flag] = (localStorage[index].toUpperCase() === "TRUE");
                }
                else
                    FlagNotCached.push(flag);
            }
            else {
                FlagNotCached.push(flag);
            }
        });
        return { 'Features': FlagNotCached, 'FeatureFlagsResult': FeatureFlagsResult };
    };
    FeatureFlagService.$inject = ['$http'];
    return FeatureFlagService;
}());
export { FeatureFlagService };
var FeatureFlagServiceProvider = /** @class */ (function () {
    function FeatureFlagServiceProvider() {
        this.$get.$inject = ['$http', '$q'];
    }
    FeatureFlagServiceProvider.prototype.$get = function ($http, $q) {
        return new FeatureFlagService($http, this._featureFlagConfig, this._context, $q);
    };
    FeatureFlagServiceProvider.prototype.configure = function (featureFlagConfig, context) {
        this._featureFlagConfig = featureFlagConfig;
        this._context = context;
    };
    return FeatureFlagServiceProvider;
}());
export { FeatureFlagServiceProvider };
//# sourceMappingURL=FeatureFlagServiceProvider.js.map